import React from "react";

export const PlatformIconData = [
    {id: 'fab fa-android', name: 'ANDROID', value: 'fab fa-android'},
    {id: 'fab fa-apple', name: 'IOS', value: 'fab fa-apple'}
]